<template>
    <div class="total">
        <div class="total__title">
            <div class="total__text">ИТОГО:</div>
            <div class="total__comment" v-if="discountPercent != 0">Стоимость ТО в месяц (со&nbsp;скидкой)</div>
            <div class="total__comment" v-else>Стоимость ТО в месяц</div>

            <transition name="fade">
                <div class="total__comment border-top large-text" v-if="discountPercent != 0">Ваша скидка составила:
                    <span style="font-weight: 700">{{ discountPercent }} % -
                        {{ formattedNum(discountSumm) }}</span>
                </div>
            </transition>
            <div class="total__year">
                <p class="total__year--text">Стоимость ТО в год составляет: <span style="font-weight: 700"> {{
                formattedNum(totalSummInYear) }}</span></p>
            </div>
        </div>
        <div class="total__summ">
            {{ formattedNum(totalSummInMonth) }}
        </div>


    </div>
</template>

<script>
export default {
    name: "TotalSumm",
    data() {
        return {
            // discoiunt - скидка в процентах
            progressiveDiscount: {
                range1: {
                    min: 10000,
                    max: 20000,
                    // discount: 0.95
                    discount: 5
                },
                range2: {
                    min: 20000,
                    max: 50000,
                    // discount: 0.9
                    discount: 10
                },
                range3: {
                    min: 50000,
                    max: 100000,
                    // discount: 0.85
                    discount: 15
                },
                range4: {
                    min: 100000,
                    max: 1000000000000,
                    // discount: 0.8
                    discount: 20
                },

            },
            // сумма скидки
            discountSumm: 0,
            // процент скидки
            discountPercent: 0,
            // итоговая сумма с учетом скидки, если она есть
            summWithDiscountInMonth: 0,
        }
    },

    props: {
        hardware: {
            type: Object,
            default: () => { }
        },
        tariff: {
            type: Number,
            default: 0
        }
    },

    computed: {
        totalSummInMonth() {
            // сумма без скидки и со скидкой
            let summNoDiscountInMonth = 0
            let summWithDiscountInMonth = 0
            // процент скидки 
            let discountPercent = 0

            this.hardware.forEach(item => {
                // посчитаем сумму ТО в месяц без скидки
                summNoDiscountInMonth += item.hours * item.count * this.tariff / 12

            })

            // найдем какая скидка положена клиенту
            for (let i in this.progressiveDiscount) {
                if (summNoDiscountInMonth > this.progressiveDiscount[i].min && summNoDiscountInMonth <= this.progressiveDiscount[i].max) {
                    discountPercent = this.progressiveDiscount[i].discount
                }
            }
            this.discountPercent = discountPercent

            // какая сумма скидки 
            this.discountSumm = summNoDiscountInMonth * discountPercent / 100

            // какая итоговая сумма с учетом скидки, если она есть
            this.summWithDiscountInMonth = summNoDiscountInMonth - summNoDiscountInMonth * discountPercent / 100

            // console.log('Сумма Без скидки = ', summNoDiscountInMonth)
            // console.log('Со скидкой = ', this.summWithDiscountInMonth)

            return this.summWithDiscountInMonth
        },
        totalSummInYear() {
            return this.summWithDiscountInMonth * 12
        },

        formattedNum() {
            return num => new Intl.NumberFormat('ru-RU', {
                style: 'currency',
                currency: 'RUB',
            }).format(num)
        },

    }
}
</script>

<style lang="scss" scoped>
.total {
    max-width: 620px;
    width: 100%;
    min-height: 90px;
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    gap: 40px;
    border-bottom: 2px solid #e21414;
    border-top: 1px dotted gray;
    padding: 15px 0 0;
    margin-top: 10px;
}

.total__text {
    text-align: left;
    font-weight: 700;
    font-size: 24px;
    text-transform: uppercase;
}

.total__summ {
    color: #e21414;
    font-size: 24px;
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 10px;
}

.total__comment {
    font-size: 15px;
    text-align: left;
}

.total__year {
    margin-top: 15px;
    border-top: 1px dotted grey;
}

.total__year--text {
    margin: 0;
    padding-top: 5px;
    text-align: left;
}

.border-top {
    border-top: 1px solid black;
}

.large-text {
    font-size: 18px;
}

.fade-enter-active,
.fade-leave-active {
    transition: 0.5s;
    
}

.fade-enter-from,
.fade-leave-to {
    transition: 0.5s;
    opacity: 0;
}

</style>